import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Layout, Button, Row, Col, Icon, Spin } from 'antd';
import { PublicRoutes, AuthenticatedRoutes } from './routes';
import { logOutUser, getUserInfo } from './redux/action/auth/AuthActions';
import { setNavigationKey } from './redux/action/navigation/NavigationActions';
import { FullScreenSpinner } from './components/spinner/FullScreenSpinner';
import { NotAuthorized } from './pages/error/403/NotAuthorized';
import NavigationBar from './components/navigation/NavigationBar';
import { MENU_ITEMS } from './components/navigation/NavigationBarConstants';
import _ from 'lodash';

const { Header, Content } = Layout;

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      waitingMeData: false,
      adminRole: false,
      accessDenied: false,
      renderRoute: false
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const menuOptions = _.find(MENU_ITEMS, {
      path: window.location.pathname
    });

    if (window.location.pathname === '/search/usage_url') {
      this.props.setNavigationKey('table');
      return;
    }

    if (window.location.pathname === '/search/clickhouse_usage_url') {
      this.props.setNavigationKey('table');
      return;
    }

    const selectedKey = menuOptions ? menuOptions.key : '';
    this.props.setNavigationKey(selectedKey);
  }

  updateMeData = () => {
    this.setState(
      {
        waitingMeData: true
      },
      () => {
        this.props.getUserInfo().then(() => {
          if (!_.isEmpty(this.props.userInfoErrorMessage)) {
            this.setState({
              accessDenied: true,
              renderRoute: true,
              waitingMeData: false
            });

            window.localStorage.clear();
            window.location.href = '/login';
          } else {
            if (_.includes(this.props.userInfo.roles, 'ROLE_ADMIN')) {
              this.setState({
                userInfo: this.props.userInfo,
                adminRole: true,
                accessDenied: false,
                renderRoute: true,
                waitingMeData: false
              });
              // this.props.history.push('/admin-panel')
            } else {
              this.setState({
                userInfo: this.props.userInfo,
                adminRole: false,
                accessDenied: false,
                renderRoute: true,
                waitingMeData: false
              });
            }
          }
        });
      }
    );
  };

  logoutUser = () => {
    Promise.resolve(this.props.logOutUser()).then(() => {
      window.location.pathname = '/login';
    });
    // this.props.logOutUser().then(() => {
    //   window.location.pathname = '/'
    // })
  };

  renderAuthenticatedPage = (adminRole) => {
    !this.state.waitingMeData &&
      _.isEmpty(this.props.userInfo) &&
      this.updateMeData();
    return (
      <Layout style={{ minHeight: '100vh' }}>
        <Spin spinning={this.props.userInfoIsFetching}>
          <FullScreenSpinner>
            <Layout>
              <Header
                style={{
                  background: '#fff',
                  padding: '0 15px'
                }}
              >
                <Row type='flex'>
                  <Col span={24}>
                    <div className='user-info-wrapper'>
                      <NavigationBar />
                      {/*<div*/}
                      {/*  className="admin-menu-panel"*/}
                      {/*  ref="user-header-button-content"*/}
                      {/*/>*/}
                      <div className='user-info-header'>
                        <div className='user-info'>
                          {this.props.userInfo.login}
                        </div>
                        <div>
                          <Button
                            type='button'
                            style={{
                              marginLeft: 5
                            }}
                            onClick={() => this.logoutUser()}
                          >
                            Exit
                            <Icon type='export' />
                          </Button>
                        </div>
                      </div>
                      {/*<Button type="primary"><Link to="/">Home Page</Link></Button>                      */}
                    </div>
                  </Col>
                </Row>
              </Header>
              <Content
                className='App'
                style={{
                  margin: '24px 16px',
                  padding: 24,
                  background: '#fff',
                  minHeight: 'calc(85vh)'
                }}
              >
                {this.state.renderRoute ? AuthenticatedRoutes(adminRole) : null}
                {/*{this.state.renderRoute ? this.props.history.push(adminRole ? '/admin-panel' : '/'): null}*/}
              </Content>
            </Layout>
            <div
              style={{
                position: 'fixed',
                bottom: 0,
                textAlign: 'center',
                backgroundColor: '#fff',
                color: '#777575',
                fontSize: '14px',
                fontWeight: '400',
                width: '100%',
                padding: '2px'
              }}
            >
              Production v.2.18.1
            </div>
          </FullScreenSpinner>
        </Spin>
      </Layout>
    );
  };

  render() {
    // return this.renderAuthenticatedPage()
    const { adminRole, accessDenied } = this.state;
    if (this.props.token) {
      if (accessDenied) {
        return <NotAuthorized />;
      } else {
        return this.renderAuthenticatedPage(adminRole);
      }
    } else {
      return <PublicRoutes />;
    }
  }
}

function mapDispatchToProps(dispatch) {
  return {
    logOutUser: bindActionCreators(logOutUser, dispatch),
    getUserInfo: bindActionCreators(getUserInfo, dispatch),
    setNavigationKey: bindActionCreators(setNavigationKey, dispatch)
  };
}

function mapStateToProps({
  auth: {
    token,
    authStatus,
    userInfo,
    userInfoErrorMessage,
    userInfoIsFetching
  }
}) {
  return {
    token,
    authStatus,
    userInfo,
    userInfoErrorMessage,
    userInfoIsFetching
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));
